/** @jsxImportSource @emotion/react */

import { useField } from 'react-final-form'
import { FC } from 'react'
import { InputField } from 'components/Input'
import * as advancedFieldArrayClasses from 'components/AdvancedFieldArray/styles'
import { validateRequired } from 'utils/validation'
import * as classes from './styles'

export const BOOSTER_PREMIUM_PRICE = 'boosterPremiumPrice' as const
export const BOOTCAMP_PRO_PRICE = 'bootcampProPrice' as const

type Props = {
  platformName?: string
  alternativeName?: string
}

export const PriceRow: FC<Props> = ({ platformName = 'Booster Premium', alternativeName = 'Bootcamp Pro' }) => {
  const { meta: boosterPremiumMeta } = useField<string>(BOOSTER_PREMIUM_PRICE)
  const { meta: bootcampProMeta } = useField<string>(BOOTCAMP_PRO_PRICE)

  const isBoosterPremiumError =
    boosterPremiumMeta.touched && (boosterPremiumMeta.error || boosterPremiumMeta.submitError)
  const isBootcampProError = bootcampProMeta.touched && (bootcampProMeta.error || bootcampProMeta.submitError)

  return (
    <div css={[advancedFieldArrayClasses.item(isBoosterPremiumError || isBootcampProError), classes.priceRow]}>
      <div css={classes.featureArrayFieldWrapper}>
        <div css={classes.featureArrayFieldItem} />
        <div css={classes.featureArrayFieldItem}>
          <InputField
            name={BOOSTER_PREMIUM_PRICE}
            css={classes.input}
            size="small"
            placeholder={`${platformName} Price`}
            validate={validateRequired}
            hideErrorMessage
          />
        </div>
        <div css={classes.featureArrayFieldItem}>
          <InputField
            name={BOOTCAMP_PRO_PRICE}
            css={classes.input}
            size="small"
            placeholder={`${alternativeName} Price`}
            validate={validateRequired}
            hideErrorMessage
          />
        </div>
      </div>
      <div css={classes.dummyActions} />
    </div>
  )
}
